import React from 'react'
import styles from './AdminHeader.module.scss'
import { Icon } from 'components/shared/Icon/Icon'
import { ChevronRightIcon } from 'components/shared/Icon/model'

import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'

export const AdminHeader = ({
  selectedUser,
  department,
  setUser,
  search,
  setSearch,
}) => (
  <div className={styles.adminHeader}>
    {selectedUser ? (
      <>
        <div className={styles.crumbs}>
          <span
            onClick={() => {
              setUser(selectedUser.id)
            }}
            className={styles.userName}
          >{`${selectedUser.first_name} ${selectedUser.last_name}`}</span>
          <Icon className={styles.icon} icon={ChevronRightIcon} />
          <span>{department.name}</span>
        </div>
      </>
    ) : null}
    <SearchWidget
      query={search}
      onChange={setSearch}
      className={styles.search}
    />
  </div>
)
